/**
 * 判断是否在中国大陆范围内（用于 GCJ-02 加密）
 */
 function outOfChina(lat, lng) {
    if (lng < 72.004 || lng > 137.8347) return true;
    if (lat < 0.8293 || lat > 55.8271) return true;
    return false;
  }
  
  /**
   * WGS-84 转 GCJ-02（火星坐标）
   */
  function transformFromWGSToGCJ(wgLat, wgLon) {
    if (outOfChina(wgLat, wgLon)) {
      return { lat: wgLat, lng: wgLon };
    }
  
    let dLat = transformLat(wgLon - 105.0, wgLat - 35.0);
    let dLon = transformLon(wgLon - 105.0, wgLat - 35.0);
    let radLat = wgLat / 180.0 * Math.PI;
    let magic = Math.sin(radLat);
    magic = 1 - 0.00669342162296594323 * magic * magic;
    const sqrtMagic = Math.sqrt(magic);
    dLat = (dLat * 180.0) / ((6378206.4 * (1 - 0.00669342162296594323)) / (magic * sqrtMagic) * Math.PI);
    dLon = (dLon * 180.0) / (6378206.4 / sqrtMagic * Math.cos(radLat) * Math.PI);
    return {
      lat: wgLat + dLat,
      lng: wgLon + dLon
    };
  }
  
  function transformLat(x, y) {
    let ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(y * Math.PI) + 40.0 * Math.sin(y / 3.0 * Math.PI)) * 2.0 / 3.0;
    ret += (160.0 * Math.sin(y / 12.0 * Math.PI) + 320 * Math.sin(y * Math.PI / 30.0)) * 2.0 / 3.0;
    return ret;
  }
  
  function transformLon(x, y) {
    let ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(x * Math.PI) + 40.0 * Math.sin(x / 3.0 * Math.PI)) * 2.0 / 3.0;
    ret += (150.0 * Math.sin(x / 12.0 * Math.PI) + 300.0 * Math.sin(x / 30.0 * Math.PI)) * 2.0 / 3.0;
    return ret;
  }
  
  /**
   * GCJ-02 转 BD-09
   */
  function transformFromGCJToBaidu(gcjLat, gcjLng) {
    const x = gcjLng;
    const y = gcjLat;
    const z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * Math.PI * 3000.0 / 180.0);
    const theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * Math.PI * 3000.0 / 180.0);
    const bdLng = z * Math.cos(theta) + 0.0065;
    const bdLat = z * Math.sin(theta) + 0.006;
    return { lat: bdLat, lng: bdLng };
  }
  
  /**
   * WGS-84 直接转 BD-09
   */
  function wgsToBaidu(wgsLat, wgsLng) {
    const gcj = transformFromWGSToGCJ(wgsLat, wgsLng);
    return transformFromGCJToBaidu(gcj.lat, gcj.lng);
  }

    // 百度坐标转高德坐标
  function bd09ToGcj02(bdLng, bdLat) {
      const x = bdLng - 0.0065;
      const y = bdLat - 0.006;
      const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * Math.PI);
      const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * Math.PI);
      const ggLng = z * Math.cos(theta);
      const ggLat = z * Math.sin(theta);
      return [ggLng, ggLat];
  }
  
  // 使用示例
  /*
  const wgs = { lat: 39.915, lng: 116.404 };
  const bd = wgsToBaidu(wgs.lat, wgs.lng);
  console.log('百度坐标:', bd.lng, bd.lat); // 可用于 BMap.Point
  */

  export  default{
    wgsToBaidu,
    bd09ToGcj02
}